import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import configureStore from "../TeamManager/store/teamManagerStore";
import SettingsTeamDetails from "./components/SettingsTeamDetails";

const SettingsTeamDetailsApp = (props) => {
  const { settingsPath, lastEditedAt, changelogVersions, ...teamManagerProps } = props;

  return (
    <Provider store={configureStore(teamManagerProps)}>
      <ToastContainer icon={false} />
      <SettingsTeamDetails settingsPath={settingsPath} lastEditedAt={lastEditedAt} changelogVersions={changelogVersions} />
    </Provider>
  );
};

export default SettingsTeamDetailsApp;
